// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2YalO","row":"ProcedureTreatmentSummary_row__2YawA"};